import { useEffect, useState } from 'react';
import { isFirstOfflineDataRestoring } from '../offlineQueryClient';

export const useOfflineQueryClientAlreadyHydratedInFirstRender = () => {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    const validateHydration = async () => {
      await isFirstOfflineDataRestoring;
      setHydrated(true);
    };

    validateHydration();
  }, []);

  return hydrated;
};
